import React from 'react';
import { Badge } from './ui/badge';

const roleColors = {
  'Rep': { bg: 'bg-[#F1F5F9]', text: 'text-[#475569]', border: 'border-[#CBD5E1]' },
  'District_Leader': { bg: 'bg-[#EFF6FF]', text: 'text-[#1D4ED8]', border: 'border-[#BFDBFE]' },
  'Division_Leader': { bg: 'bg-[#F0FDF4]', text: 'text-[#15803D]', border: 'border-[#BBF7D0]' },
  'Regional_Leader': { bg: 'bg-[#FFF7ED]', text: 'text-[#C2410C]', border: 'border-[#FED7AA]' },
  'Senior_Regional_Leader': { bg: 'bg-[#FAF5FF]', text: 'text-[#7E22CE]', border: 'border-[#E9D5FF]' },
  'Regional_Vice_President': { bg: 'bg-[#FEFCE8]', text: 'text-[#A16207]', border: 'border-[#FEF08A]' },
  'Admin': { bg: 'bg-[#FEF2F2]', text: 'text-[#B91C1C]', border: 'border-[#FECACA]' }
};

const roleLabels = {
  'Rep': 'Rep',
  'District_Leader': 'District Leader',
  'Division_Leader': 'Division Leader',
  'Regional_Leader': 'Regional Leader',
  'Senior_Regional_Leader': 'SRL',
  'Regional_Vice_President': 'RVP',
  'Admin': 'Admin'
};

export const RoleBadge = ({ role }) => {
  const colors = roleColors[role] || roleColors['Rep'];
  const label = roleLabels[role] || role;

  return (
    <Badge 
      data-testid={`role-badge-${role}`}
      className={`${colors.bg} ${colors.text} border ${colors.border} font-semibold`}
    >
      {label}
    </Badge>
  );
};
